import { render, staticRenderFns } from "./LogoutOtherBrowserSessionsForm.vue?vue&type=template&id=21ad4f5e&scoped=true&"
import script from "./LogoutOtherBrowserSessionsForm.vue?vue&type=script&lang=js&"
export * from "./LogoutOtherBrowserSessionsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ad4f5e",
  null
  
)

export default component.exports